import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SharedModule } from "app/shared/shared.module";
import { DetalhesCursoRouter } from "./detalhe-curso.router";
import { DetalheCursoComponent } from "./detalhe-curso.component";
import { SharedPosGraduacaoModule } from '../../shared/shared-pos-graduacao.module';
import { SobreOProgramaComponent } from "./sobre-o-programa/sobre-o-programa.component";
import { DisciplinasComponent } from "./disciplinas/disciplinas.component";
import { CorpoDocenteComponent } from "./corpo-docente/corpo-docente.component";
import { ProcessoSeletivoComponent } from "./processo-seletivo/processo-seletivo.component";


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        DetalhesCursoRouter,
        SharedPosGraduacaoModule,
    ],
    declarations: [
        DetalheCursoComponent,
        SobreOProgramaComponent,
        DisciplinasComponent,
        CorpoDocenteComponent,
        ProcessoSeletivoComponent
    ]
})

export class DetalhesCursoModule {}